import { render, staticRenderFns } from "./ColumnarContent.vue?vue&type=template&id=76ce5654"
import script from "./ColumnarContent.vue?vue&type=script&lang=js"
export * from "./ColumnarContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports